namespace Platform {
  export const isClient = typeof window !== "undefined";
}

export default Platform;
